import { shuffleArray } from '~/utils/array';

import { WORDS, type WordGuessWord } from '../_data/words';

const STORAGE_KEY = 'word-guess-remaining';

const WORDS_BY_KEY = new Map<string, WordGuessWord>(WORDS.map((word) => [word.word, word]));

function createShuffledDeck(): string[] {
  return shuffleArray(WORDS.map((word) => word.word));
}

function loadRemainingWords(): string[] {
  if (typeof window === 'undefined') return [];

  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return [];

    const parsed = JSON.parse(stored) as unknown;
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((word): word is string => typeof word === 'string' && WORDS_BY_KEY.has(word));
  } catch {
    return [];
  }
}

function saveRemainingWords(words: string[]) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(words));
}

export function getNextWord(): WordGuessWord {
  let remaining = loadRemainingWords();

  if (remaining.length === 0) {
    remaining = createShuffledDeck();
  }

  const [nextWord, ...rest] = remaining;
  saveRemainingWords(rest);

  return WORDS_BY_KEY.get(nextWord)!;
}
